export function isEmptyOrFalsy(value: any): boolean {
	return (
		typeof value === 'undefined'
		|| value === ''
		|| value === null
		|| (Array.isArray(value) && !value.length)
		|| (typeof value === 'object' && !Object.keys(value).length)
	);
}
